"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackGeoAction = exports.GEO_SET_METHODS = exports.GEO_OPEN_MAP_SOURCES = exports.GEO_EVENTS = exports.GEO_ACTIONS = void 0;
var _trackEvent = require("./trackEvent");
const GEO_EVENTS = exports.GEO_EVENTS = {
  COORDINATES: "coordinates",
  OPEN_MAP_VIEW: "map_view.open"
};
const GEO_ACTIONS = exports.GEO_ACTIONS = {
  SET: "set",
  EDIT: "edit",
  REMOVE: "remove"
};
const GEO_SET_METHODS = exports.GEO_SET_METHODS = {
  PLACED_WITH_MAP: "Place location on map",
  TEXT_INPUT: "Text Input"
};
const GEO_OPEN_MAP_SOURCES = exports.GEO_OPEN_MAP_SOURCES = {
  DETAILS: "issue details",
  MAP_BUTTON: "map button"
};
const trackGeoAction = (actionName, parameters) => {
  (0, _trackEvent.trackEvent)({
    name: "issue.gps.".concat(actionName),
    parameters: parameters
  });
};
exports.trackGeoAction = trackGeoAction;
//# sourceMappingURL=geoActionTracking.js.map